import React, { useRef } from 'react';

import PropTypes from 'prop-types';

import { BackwardsCompatibleMutableRefObject } from '@adsk/alloy-react-helpers';
import { useTheme } from '@adsk/alloy-react-styles';
import { stylePropType, StylableComponent } from '@adsk/alloy-react-theme';

import { useMenuNavigation } from '../hooks/useMenuNavigation';

type MenuListProps = StylableComponent<HTMLDivElement>;
/** A MenuList component which wraps an HTML unordered list */
const MenuList = React.forwardRef<HTMLDivElement, MenuListProps>(
  ({ children, style, className }, ref) => {
    const internalRef = useRef<HTMLDivElement>(null);
    useMenuNavigation(internalRef);
    const dynamicTheme = useTheme();
    const listTokens = dynamicTheme.tokens?.component?.menu?.list;

    const setRefs = (element: HTMLDivElement | null) => {
      internalRef.current = element;
      if (typeof ref === 'function') {
        ref(element);
      } else if (ref) {
        (
          ref as BackwardsCompatibleMutableRefObject<HTMLDivElement | null>
        ).current = element;
      }
    };

    return (
      <div
        ref={setRefs}
        className={className}
        role="menu"
        css={[listTokens, style]}
      >
        {children}
      </div>
    );
  },
);

MenuList.displayName = 'MenuList';

MenuList.propTypes = {
  /** The content to category */
  children: PropTypes.any,
  /* Styles applied to the root element */
  style: stylePropType,
  /* Class applied to the root element */
  className: PropTypes.string,
};
export default MenuList;
